// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"539bfe0b","703":"887d393b"}[chunkId] + ".chunk.js";
};